import { useEffect, useState } from 'react';
import { useIsFetching } from '@tanstack/react-query';
import { Box } from '@mantine/core';

/**
 * Thin global loading bar for async data fetches.
 * It intentionally ignores very short fetches to avoid flicker.
 */
export const GlobalLoadingIndicator = () => {
  const isFetching = useIsFetching();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (isFetching > 0) {
      const t = window.setTimeout(() => setVisible(true), 200);
      return () => window.clearTimeout(t);
    }

    setVisible(false);
    return undefined;
  }, [isFetching]);

  if (!visible) {
    return null;
  }

  return (
    <Box
      pos="fixed" left={0} top={0} h={2} w="100%"
      style={{zIndex:100,pointerEvents:'none',overflow:'hidden'}}
      role="status"
      aria-label="Loading"
    >
      <Box style={{width:'33.3%',animation:'loading-bar 1.1s ease-in-out infinite',height:'100%',backgroundColor:'var(--mantine-primary-color-filled)'}} />
      <style>{`
        @keyframes loading-bar {
          0% { transform: translateX(-120%); }
          100% { transform: translateX(420%); }
        }
      `}</style>
    </Box>
  );
};
